module.exports = __webpack_public_path__ + "static/media/20240403_150715.e7ee3b35.jpg";